import axiSymbolWhite from '../assets/axiSymbolWhite.svg';
import axiUserSymbol from '../assets/axiUserSymbol.svg';


function ChatSpeechBubble({ message }) {
	const userIcon = message.role === 'assistant' ? axiSymbolWhite : axiUserSymbol;
	const userWho = message.role === 'assistant' ? 'Axi' : 'User';

	const time = new Date();
	const timeStamp = time.toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true });
	
	return(
		<div className={"transcript-item role " + message.role } aria-label={userWho + " Speech Bubble"}>
			<figure aria-hidden="true"><img src={userIcon} width="44" height="44" alt={userWho + " Symbol"} /></figure>
			<div aria-label={userWho + " said at " + timeStamp}><p>{message.content}</p></div>
		</div>
	);
}

export default ChatSpeechBubble;